import { useTranslation } from 'react-i18next'

import { FieldStackedLabel } from '../../../../Field'
import { FormFieldSelectNG } from '../../../../Form'
import { FormikField } from '../../../../Formik'
import { ButtonSelect } from '../../../../Select'
import { useDocFlowMappingWidgetSplittingFields } from '../../../DocFlow.hooks'
import {
  DocFlowMappingAccuracyField,
  DocFlowMappingProcessCell,
} from '../../../DocFlowMapping'

function DocFlowMappingWidgetSplittingFields({
  isLoading,
  widgetDisabled,
  onClearFieldType,
  ...restProps
}) {
  const { t } = useTranslation()

  const { handleChangeAccuracy, handleChangeType, isTypeArea, options } =
    useDocFlowMappingWidgetSplittingFields({
      ...restProps,
      widgetDisabled,
    })

  return (
    <>
      <FormikField
        Component={FormFieldSelectNG}
        Field={FieldStackedLabel}
        Select={ButtonSelect}
        controlProps={{
          contentProps: {
            placeholderProps: {
              text: t('DocumentStapling.SplittingWidgetTypePlaceholderKey'),
            },
          },
        }}
        disabled={widgetDisabled || isLoading}
        fieldComponentProps={{
          label: t('DocumentStapling.SplittingWidgetTypeFieldTitleKey'),
        }}
        name={DocFlowMappingProcessCell.SplittingType}
        options={options}
        onChange={handleChangeType}
        onClear={onClearFieldType}
      />
      {isTypeArea ? (
        <DocFlowMappingAccuracyField
          disabled={widgetDisabled || isLoading}
          name={DocFlowMappingProcessCell.SplittingMatchAccuracy}
          onChange={handleChangeAccuracy}
        />
      ) : null}
    </>
  )
}

export default DocFlowMappingWidgetSplittingFields
